import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/service/api.service';
import { RolesService } from 'src/app/shared/service/roles.service';
/* eslint-disable */

@Injectable({
  providedIn: 'root',
})
export class MeasureService {
  filters: BehaviorSubject<any> = new BehaviorSubject([]);
  timelineChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  monthTotalChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  timelineServiceChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  MonthServiceChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  storageUsageChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  storageBandwidthChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  streamDurationUserChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  streamSpendUserChartData: BehaviorSubject<any> = new BehaviorSubject(false);
  streamDurationAppsChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  streamSpendAppsChartData: BehaviorSubject<any> = new BehaviorSubject([]);
  chartLoading: BehaviorSubject<any> = new BehaviorSubject(false);
  filtersValues;
  filtersValuesChange: BehaviorSubject<any> = new BehaviorSubject({});
  currentActiveTab;
  selectedCURCols: string[] = [];
  isSelectBillableAccounts: boolean = true;
  isAdmin = this.rolesService.checkIfUserIsAdmin();
  isAccountManager = this.rolesService.checkIfUserIsAccountManger();
  ebsInstanceId;
  //Reports integrations params
  billingReportParams; //Spend By Account  //Spend By Service
  billingReportTimelineParams; //Spend By Account Over Time  //Spend By Service Over Time
  appstreamReportParams; //All appstream charts
  bandwidthChartsDataParams; //Bandwidth Over Time
  storageVolumeReportForS3BucketCostOverTimeParams; //S3 Bucket Cost Over Time
  storageReportParams; //S3 Buckets Utilization Over Time
  storageVolumeReportPrams; //S3 API Request Volume Over Time
  revenueOverTimeReportParams; //Revenue Over Time
  constructor(
    private apiService: ApiService,
    private rolesService: RolesService
  ) {}

  getAppstreamReport(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.appstreamReportParams = {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
    } else {
      this.appstreamReportParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
    }

    // Check if date range > 5 days; if so, delegate to splitter
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

    if (diffInDays > 10) {
      return this.splitAndFetchBillingReportTimeline(params, true);
    }
    // console.log(
    //   '@GetAppstreamReport() >> service >> Getting Appstream Report with params: diffInDays  >>> ',
    //   diffInDays
    // );
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.appstreamReportParams = {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.appstreamReportParams
      );
    } else {
      this.appstreamReportParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.appstreamReportParams
      );
    }

    //return this.apiService.get('reports/appstream/v2', { ...params });
  }

  getBillingReport(params) {
    // console.log(
    //   '@getBillingReport() >> service >> Monthly >>  params >> ',
    //   params
    // );

    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.billingReportParams = {
        params: params,
        filters: this.filtersValues,
        caches: false,
        billable_only: this.isSelectBillableAccounts,
      };
    } else {
      this.billingReportParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
    }

    // Check if date range > 5 days; if so, delegate to splitter
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

    if (diffInDays > 10) {
      return this.splitAndFetchBillingReportTimeline(params);
    }

    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.billingReportParams = {
        params: params,
        filters: this.filtersValues,
        caches: false,
        billable_only: this.isSelectBillableAccounts,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.billingReportParams
      );
    } else {
      this.billingReportParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.billingReportParams
      );
    }
    //return this.apiService.get('reports/billing', { ...params });
  }

  getBillingReportTimeline(params) {
    // console.log(
    //   '@getBillingReportTimeline() >> service >> timeline >> Getting Billing Report Timeline with params:',
    //   params
    // );

    // To set timeline params for scheduling
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.billingReportTimelineParams = {
        params: params,
        filters: this.filtersValues,
        caches: false,
        billable_only: this.isSelectBillableAccounts,
      };
    } else {
      this.billingReportTimelineParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
    }

    // Check if date range > 5 days; if so, delegate to splitter
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

    if (diffInDays > 10) {
      return this.splitAndFetchBillingReportTimeline(params);
    }

    // Original logic for small ranges
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.billingReportTimelineParams = {
        params: params,
        filters: this.filtersValues,
        caches: false,
        billable_only: this.isSelectBillableAccounts,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.billingReportTimelineParams
      );
    } else {
      this.billingReportTimelineParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.billingReportTimelineParams
      );
    }
  }

  // New private method for splitting and batching requests
  private splitAndFetchBillingReportTimeline(
    params,
    isAppstream = false
  ): Observable<any> {
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

    // if (diffInDays <= 5) {
    //   // Fallback: single request (shouldn't reach here due to caller check, but safe)
    //   return this.apiService.post('aws-inventory-tab', {
    //     ...params,
    //     ...((this.isAdmin || this.isAccountManager) && {
    //       billable_only: this.isSelectBillableAccounts,
    //     }),
    //     caches: false,
    //   });
    // }

    // Generate date chunks (each up to 5 days)
    const chunks: { startDate: string; endDate: string }[] = [];
    let currentStart = new Date(start);

    while (currentStart <= end) {
      const chunkEnd = new Date(currentStart);
      chunkEnd.setDate(currentStart.getDate() + 9); //+5
      if (chunkEnd > end) chunkEnd.setTime(end.getTime()); // Cap at original end

      chunks.push({
        startDate: currentStart.toISOString().split('T')[0], // Format as YYYY-MM-DD
        endDate: chunkEnd.toISOString().split('T')[0],
      });

      currentStart = new Date(chunkEnd);
      currentStart.setDate(currentStart.getDate() + 1); // Start next chunk the day after
    }
    console.log('Date chunks for billing report timeline:', chunks);
    // Create observables for each chunk (direct API calls without recursion)
    const requests = chunks.map((chunk) => {
      const chunkParams = {
        ...params,
        startDate: chunk.startDate,
        endDate: chunk.endDate,
      };
      if (this.filtersValues && this.filtersValues[0]?.column) {
        return this.apiService.post('aws-inventory-tab', {
          params: chunkParams,
          filters: this.filtersValues,
          billable_only: this.isSelectBillableAccounts,
          caches: false,
        });
      } else {
        return this.apiService.post('aws-inventory-tab', {
          params: chunkParams,
          billable_only: this.isSelectBillableAccounts,
          caches: false,
        });
      }
    });
    //console.log('@Requests to be made in parallel: >> ', requests);
    // Run all requests in parallel and combine results
    if (isAppstream) {
      /*
       * Special handling for Appstream reports:
       * Each chunk may return an array like:
       * [{ total_stopped_instances_hours: 0, total_stopped_instances_cost: 0, total_cost: 76.49768, total_hours: 1297, result: [...] }]
       * We need to merge all chunk responses into one summary object that sums numeric totals
       * and concatenates all `result` arrays into a single `result` array.
       */
      return forkJoin(requests).pipe(
        map((results: any[]) => {
          //console.log('@Appstream splitAndFetchBillingReportTimeline results:', results);

          if (
            typeof results[0] === 'object' &&
            results[0]?.hasOwnProperty('warning')
          ) {
            return results;
          }
          // Flatten possible nested arrays: requests may each return an array
          const flattened = ([] as any[]).concat(...results.filter(Boolean));

          const summary: any = {
            total_stopped_instances_hours: 0,
            total_stopped_instances_cost: 0,
            total_cost: 0,
            total_hours: 0,
            result: [],
          };

          flattened.forEach((item: any) => {
            if (!item) return;
            if (typeof item.total_stopped_instances_hours === 'number') {
              summary.total_stopped_instances_hours +=
                item.total_stopped_instances_hours;
            }
            if (typeof item.total_stopped_instances_cost === 'number') {
              summary.total_stopped_instances_cost +=
                item.total_stopped_instances_cost;
            }
            if (typeof item.total_cost === 'number') {
              summary.total_cost += item.total_cost;
            }
            if (typeof item.total_hours === 'number') {
              summary.total_hours += item.total_hours;
            }

            if (Array.isArray(item.result)) {
              summary.result = summary.result.concat(item.result);
            } else if (item.result) {
              // If result is a single object, push it
              summary.result.push(item.result);
            }
          });

          return summary;
        })
      );
    } else {
      return forkJoin(requests).pipe(
        map((results: any[]) => [].concat(...results))
      );
    }
  }

  getStorageVolumeReportForS3BucketCostOverTime(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.storageVolumeReportForS3BucketCostOverTimeParams = {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageVolumeReportForS3BucketCostOverTimeParams
      );
    } else {
      this.storageVolumeReportForS3BucketCostOverTimeParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageVolumeReportForS3BucketCostOverTimeParams
      );
    }
  }

  getStorageReport(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.filtersValuesChange.next(null);
      this.storageReportParams = {
        params,
        filters: this.filtersValues,
        caches: false,
        billable_only: this.isSelectBillableAccounts,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageReportParams
      );
    } else {
      this.storageReportParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageReportParams
      );
    }

    //return this.apiService.get('reports/s3storageusage',  { ...params });
  }

  getStorageVolumeReport(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.storageVolumeReportPrams = {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageVolumeReportPrams
      );
    } else {
      this.storageVolumeReportPrams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.storageVolumeReportPrams
      );
    }
  }

  getTags(params) {
    return this.apiService.get('reports/tags', params);
  }
  getPrefixesFilters() {
    return this.apiService.get('aws-inventory-tab/prefixes');
  }
  getColumnsFilters(params) {
    return this.apiService.get('aws-inventory-tab/columns', params);
  }
  getMainFilters(params) {
    return this.apiService.post('aws-inventory-tab', params);
  }
  getSavedFilters() {
    return this.apiService.get('aws-inventory-tab/filters');
  }
  saveFilter(params) {
    return this.apiService.post('aws-inventory-tab/filters', params);
  }
  editFilter(params, id) {
    return this.apiService.put(`aws-inventory-tab/filters/${id}`, params);
  }
  getItemsFilters(id) {
    return this.apiService.get(`aws-inventory-tab/filters/${id}`);
  }
  getLineItemAccounts() {
    return this.apiService.get('aws-inventory-tab/accounts');
  }
  deleteSavedFilter(id) {
    return this.apiService.delete(`aws-inventory-tab/filters/${id}`);
  }

  /**
   *
   * @returns List of Raw CUR Data
   */
  getRawCURDataCols() {
    return this.apiService.get('aws-inventory-tab/selections');
  }

  /**
   * Save Selected CUR cols
   */
  saveRawCURDataSelectedCols(selectedCurCols) {
    return this.apiService.put('aws-inventory-tab/selections', selectedCurCols);
  }

  /**
   *
   * @returns List of Raw CUR Data
   */
  getRawCURDataToken(params) {
    if (this.filtersValues) {
      params.filters.push(...this.filtersValues);
      return this.apiService.post('aws-inventory-tab', {
        ...params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
      // return this.apiService.post('aws-inventory-tab', {
      //   // columns: ["*"],
      //   // distinct: false,
      //   // download: true,
      //   ...params
      //   );
    } else {
      return this.apiService.post('aws-inventory-tab', {
        ...params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }

  getRawCURDataDownloadLink(token) {
    return this.apiService.get(
      `aws-inventory-tab/download?token=${encodeURIComponent(
        token
      )}&time=${new Date().getSeconds()}`
    );
  }

  getUsageType(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }

  getStorageClassForS3CostService(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
      // return this.apiService.post('aws-inventory-tab', params);
    }
  }

  getStorageUsageType(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
      // return this.apiService.post('aws-inventory-tab', params);
    }
  }

  getEC2InventoryData(params): Observable<any[]> {
    // return this.apiService.post('aws-inventory-tab', { params });
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }

  getEBSInventoryData(params): Observable<any[]> {
    // return this.apiService.post('aws-inventory-tab', { params });
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }

  getEBSInfoData(params): Observable<any[]> {
    return this.apiService.post('ec2-dashboard/ebs-info', params);
  }

  getEC2StoppedInstancesData(selectedAccountAWSId): Observable<any[]> {
    return this.apiService.get(
      `ec2-dashboard/stopped-instances?accountId=${selectedAccountAWSId}`
    );
  }

  /**
   * Call 'aws-inventory-tab' API to get Data for Bandwidth tab
   * @param params
   * @returns list of objects
   */
  getBandwidthChartsData(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      this.bandwidthChartsDataParams = {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.bandwidthChartsDataParams
      );
    } else {
      this.bandwidthChartsDataParams = {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      };
      return this.apiService.post(
        'aws-inventory-tab',
        this.bandwidthChartsDataParams
      );
    }
  }

  /**
   * Call '' API to get Data for Storage Wasabi tab
   * @param params
   * @returns list of objects
   */
  getWasabiChartsData(params) {
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = (end - start) / (1000 * 60 * 60 * 24);

    if (diffInDays > 10) {
      return this.splitAndFetchWasabiChartsData(params);
    }
    return this.apiService.get(
      `wasabi-data?startDate=${params.startDate}&endDate=${params.endDate}&CID=${params.CID}`
    );
  }

  splitAndFetchWasabiChartsData(params): Observable<any> {
    const start: any = new Date(params.startDate);
    const end: any = new Date(params.endDate);
    const diffInDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
    const chunks: { startDate: string; endDate: string }[] = [];
    let currentStart = new Date(start);

    while (currentStart <= end) {
      const chunkEnd = new Date(currentStart);
      chunkEnd.setDate(currentStart.getDate() + 9); //+5
      if (chunkEnd > end) chunkEnd.setTime(end.getTime()); // Cap at original end

      chunks.push({
        startDate: currentStart.toISOString().split('T')[0], // Format as YYYY-MM-DD
        endDate: chunkEnd.toISOString().split('T')[0],
      });

      currentStart = new Date(chunkEnd);
      currentStart.setDate(currentStart.getDate() + 1); // Start next chunk the day after
    }
    //console.log('@chunks >> ', chunks);
    const requests = chunks.map((chunk) => {
        return this.apiService.get(
          `wasabi-data?startDate=${chunk.startDate}&endDate=${chunk.endDate}&CID=${params.CID}`
        );
    });
    //console.log('@requests >> ', requests);
    return forkJoin(requests).pipe(
      map((results: any[]) => [].concat(...results))
    );
  }

  /**
   *  Call '' for Wasabi Storage Calculator tab
   * @param params
   * @returns list of objects
   */
  getWasabiStorageCalculatorData(wasabiData) {
    return this.apiService.post(`wasabi-storage-calculator`, wasabiData);
  }

  /**
   * Call 'aws-inventory-tab' API to get Billing Summary Data for Summary page
   * @param params
   * @returns list of objects
   */
  getBillingSummaryData(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }
  /**
   * Call 'support/costs' API to get Support Costs Data for Summary page
   * @param startDate
   * @returns list of objects
   */
  getBillingSummarySupportCostData(startDate) {
    return this.apiService.get(`support/costs?startDate=${startDate}`);
  }

  /**
   * Call Two API's for getting Billing Summary page data
   * @param params
   * @param startDate
   * @returns one result set for two called APIs after both finished.
   */
  getBillingSummaryApisData(params, startDate): Observable<[any, any]> {
    return forkJoin([
      this.getBillingSummaryData(params),
      this.getBillingSummarySupportCostData(startDate),
    ]);
  }

  getAwsMarketplaceItems(params) {
    if (this.filtersValues && this.filtersValues[0]?.column) {
      return this.apiService.post('aws-inventory-tab', {
        params,
        filters: this.filtersValues,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    } else {
      return this.apiService.post('aws-inventory-tab', {
        params,
        billable_only: this.isSelectBillableAccounts,
        caches: false,
      });
    }
  }

  getAWSCreditsItems() {
    return of([
      {
        CreditName: 'Q3 T&C Promo Credits',
        CreditStatus: 'Active',
        ExpirationDate: '2025-07-04',
        AmountUsed: 12323,
        AmountRemaining: 1520,
      },
      {
        CreditName: 'Q3 T&C Promo Credits 2',
        CreditStatus: 'Active',
        ExpirationDate: '2025-09-20',
        AmountUsed: 9998,
        AmountRemaining: 7668,
      },
      {
        CreditName: 'Q3 T&C AWS Credit',
        CreditStatus: 'Expired',
        ExpirationDate: '2025-05-01',
        AmountUsed: 999,
        AmountRemaining: 776,
      },
      {
        CreditName: 'Q3 T&C AWS Credit Online',
        CreditStatus: 'Expired',
        ExpirationDate: '2025-06-01',
        AmountUsed: 9987,
        AmountRemaining: 657,
      },
    ]);
    return this.apiService.get(`schedule/reports?` + Math.random());
  }

  getRoute53HostedZones(startDate, endDate, selectedAccountAWSId) {
    //console.log('Fetching Route53 Hosted Zones for account:', selectedAccountAWSId, ' >> ' , startDate , ' - ', endDate);
    // If startDate and endDate are provided, include them in the API call
    // Otherwise, just fetch all DNS records without date filtering
    if (startDate !== '' && endDate !== '') {
      return this.apiService.get(
        `route53/hosted-zones?account_id=${selectedAccountAWSId}&startDate=${startDate}&endDate=${endDate}&allDnsRecords=true`
      );
    } else {
      return this.apiService.get(
        `route53/hosted-zones?account_id=${selectedAccountAWSId}&allDnsRecords=true`
      );
    }
    return of({
      totalZones: 44,
      totalRecords: 688,
      totalQueries: 3599572,
      averageRecords: 16,
      averageQueries: 81808,
      timeRange: '2025-07-14T13:13:22.740062 to 2025-07-15T13:13:22.740062',
      hostedZones: [
        {
          totalRecords: 8,
          totalQueries: 0,
          id: 'Z10002451W5WXDIY2HH5N',
          name: 'dev.cookchildrens.org.',
          dnsRecords: [],
        },
        {
          totalRecords: 21,
          totalQueries: 71693,
          id: 'Z06111203BN6AKONWCHYJ',
          name: 'cookchp.org.',
          dnsRecords: [
            {
              Name: 'epiccarelink.cookchp.org',
              Type: 'A',
              Total: 24981,
              Success: 24981,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'cookchp.org',
              Type: 'A',
              Total: 11886,
              Success: 11886,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'www.cookchp.org',
              Type: 'A',
              Total: 9212,
              Success: 9212,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'epiccarelink.cookchp.org',
              Type: 'AAAA',
              Total: 5056,
              Success: 5056,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'providers.cookchp.org',
              Type: 'A',
              Total: 3363,
              Success: 3363,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'mycookchildrens.cookchp.org',
              Type: 'A',
              Total: 3288,
              Success: 3288,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'www.cookchp.org',
              Type: 'AAAA',
              Total: 2958,
              Success: 2958,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'epiccarelink.cookchp.org',
              Type: 'HTTPS',
              Total: 2725,
              Success: 2725,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
            {
              Name: 'mycookchildrens.cookchp.org',
              Type: 'AAAA',
              Total: 1271,
              Success: 1271,
              NotFound: 0,
              ServerFailure: 0,
              Refused: 0,
            },
          ],
        },
      ],
    }).pipe(delay(3000));
  }

  setupRoute53Reporting(selectedAccountAWSId) {
    // console.log('Setting up Route53 Reporting for account:', selectedAccountAWSId);
    return this.apiService.post('onboard/route53', {
      account_id: selectedAccountAWSId,
      run: true,
    });
  }

  scheduleReport(chartTitle, scheduleParams, reportName, ccEmails) {
    let paramsObject;
    if (chartTitle == 'Spend By Account' || chartTitle == 'Spend By Service') {
      paramsObject = {
        ...this.billingReportParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'bar',
      };
    } else if (
      chartTitle == 'Spend By Account Over Time' ||
      chartTitle == 'Spend By Service Over Time'
    ) {
      paramsObject = {
        ...this.billingReportTimelineParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (
      chartTitle == 'Duration By User' ||
      chartTitle == 'Spend By User' ||
      chartTitle == 'Duration By Application' ||
      chartTitle == 'Spend By Application'
    ) {
      paramsObject = {
        ...this.appstreamReportParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'bar',
      };
    } else if (
      chartTitle == 'Duration By User Over Time' ||
      chartTitle == 'Spend By User Over Time' ||
      chartTitle == 'Duration By Application Over Time' ||
      chartTitle == 'Spend By Application Over Time'
    ) {
      paramsObject = {
        ...this.appstreamReportParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (chartTitle == 'Bandwidth Over Time') {
      paramsObject = {
        ...this.bandwidthChartsDataParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (chartTitle == 'S3 Bucket Cost Over Time') {
      paramsObject = {
        ...this.storageVolumeReportForS3BucketCostOverTimeParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (chartTitle == 'S3 Buckets Utilization Over Time') {
      paramsObject = {
        ...this.storageReportParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (chartTitle == 'S3 API Request Volume Over Time') {
      paramsObject = {
        ...this.storageVolumeReportPrams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'line',
      };
    } else if (chartTitle == 'Revenue Over Time') {
      paramsObject = {
        ...this.revenueOverTimeReportParams,
        schedule: scheduleParams,
        report_name: reportName,
        chartType: 'bar',
      };
    }
    paramsObject = { ...paramsObject, cc_emails: ccEmails };
    return this.apiService.post('schedule/reports/', paramsObject);
  }
}
